import { Smartphone } from 'lucide-react';
import MobileSimulator from './mobile/MobileSimulator';
import PreTripInspection from './mobile/PreTripInspection';

export default function DriverMobileApp() {
  return (
    <section aria-label="Driver mobile app simulator" className="space-y-5">
      <div className="border-b border-logi-grid pb-4">
        <div className="mb-2 flex items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-logi-accent/10 ring-1 ring-logi-accent/30">
            <Smartphone className="h-4 w-4 text-logi-accent" strokeWidth={1.75} />
          </div>
          <span className="text-xs font-semibold uppercase tracking-widest text-logi-accent/80">
            OGTS LogiCore™ · Modules 5 &amp; 6 · Field Operations Prototype
          </span>
        </div>
        <h2 className="text-xl font-bold tracking-tight text-logi-text sm:text-2xl">
          Driver Mobile App Simulator
        </h2>
        <p className="mt-1 text-sm text-logi-muted">
          Side-by-side driver trip view &amp; admin pre-trip safety verification
        </p>
      </div>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(280px,360px)_1fr] lg:items-start">
        {/* Left — Mobile simulator */}
        <div className="flex justify-center lg:sticky lg:top-6">
          <MobileSimulator />
        </div>

        {/* Right — Pre-trip inspection */}
        <div className="rounded-2xl border border-logi-grid bg-white p-5 sm:p-6">
          <PreTripInspection />
        </div>
      </div>
    </section>
  );
}
